import React from 'react';
import { Box } from '../Box/Box';
import { Stack } from '../Stack/Stack';
import { Legal } from '../Legal/Legal';
import { Link } from '../Link/Link';
/**
 * Possible product types that can be used to modify the Editorial Standards message.
 * More can be added should the need arise.
 * product types: https://github.com/NerdWallet/js-nw-api-sdk/blob/master/src/marketplace-sdk/constants.js#L35-L43
 */

var ADDITIONAL_MESSAGES = {
  investing: 'The investing information provided on this page is for educational purposes only.  NerdWallet does not offer advisory or brokerage services, nor does it recommend or advise investors to buy or sell particular stocks or securities.'
};
export var EditorialStandards = function EditorialStandards(_ref) {
  var className = _ref.className,
      type = _ref.type;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "neutral-lightest",
    padding: "2",
    className: className
  }, /*#__PURE__*/React.createElement(Stack, {
    dividers: 2,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Legal, {
    light: true,
    inline: true
  }, "Many or all of the products featured here are from our partners who compensate us. This may influence which products we write about and where and how the product appears on a page. However, this does not influence our evaluations. Our opinions are our own. Here is a list of", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://www.nerdwallet.com/blog/our-partners/"
  }, "our partners"), ' ', "and", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://www.nerdwallet.com/blog/advertiser-disclosure/"
  }, "here's how we make money"), "."), type && Object.prototype.hasOwnProperty.call(ADDITIONAL_MESSAGES, type) && /*#__PURE__*/React.createElement(Legal, {
    light: true,
    inline: true
  }, ADDITIONAL_MESSAGES[type])));
};